import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaShieldAlt } from "react-icons/fa";
import { FaBoltLightning } from "react-icons/fa6";
import { RiGlobalLine } from "react-icons/ri";
import { verifySignIn } from "../../api/api";
import { requestOtp } from "../../utils/otpUtils";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import AuthLayout from "../layout/AuthLayout";
import AuthBranding from "./AuthBranding";
import VerifyFormPanel from "./VerifyFormPanel";
import "../custom.css";

const verifySigninFeatures = [
  { icon: <FaShieldAlt size={22} color="#6FE6B8" />, text: "Encrypted Verification" },
  { icon: <FaBoltLightning size={22} color="#6FE6B8" />, text: "Instant OTP Delivery" },
  { icon: <RiGlobalLine size={22} color="#6FE6B8" />, text: "Global Security" },
];

const VerifySignin = () => {
  const location = useLocation();
  const { email } = location.state || {};
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleOtpSubmit = async (otp) => {
    if (!otp || otp.length < 6) {
      toast.error("Please enter complete 6-digit OTP");
      return;
    }
    setLoading(true);
    try {
      let formData = { email, otp };
      let response = await verifySignIn(formData);
      if (response.success === true) {
        toast.success(response.message || "Verification Successful!");
        localStorage.setItem("user", JSON.stringify(response.user));
        login(response.token);
        navigate("/dashboard");
      } else {
        toast.error(response.message || "Invalid OTP");
      }
    } catch (err) {
      toast.error(err.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const contentPanel = (
    <AuthBranding
      accentText="Two-Factor"
      titleSuffix="Authentication"
      subtitle="Enter the 6-digit OTP code sent to your email to verify your login identity."
      features={verifySigninFeatures}
    />
  );

  const formPanel = (
    <VerifyFormPanel
      title="Verify Sign In"
      email={email}
      onSubmit={handleOtpSubmit}
      onResendOtp={() => requestOtp({ email })}
      loading={loading}
      submitText="Verify & Sign In"
      loadingSubmitText="Verifying..."
    />
  );

  return (
    <AuthLayout
      contentPosition="right"
      contentPanel={contentPanel}
      formPanel={formPanel}
    />
  );
};

export default VerifySignin;
